"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const StyledInput = styled_1.default(react_core_1.Input.withComponent('select')) `
  background-color: ${styled_tools_1.prop('theme.gray0')};
  outline: none;
  ${styled_tools_1.prop('theme.fonts.axiformaRegular')};
  ${styled_tools_1.prop('theme.fontStyles.body1')};
  height: 1.46428em;
`;
exports.Selector = (_a) => {
    var { options, selected, onChange } = _a, props = tslib_1.__rest(_a, ["options", "selected", "onChange"]);
    return (React.createElement(StyledInput, Object.assign({}, props, { value: selected, onChange: (event) => onChange(event.target.value) }), options.map((option) => (React.createElement("option", { key: option }, option)))));
};

//# sourceMappingURL=Selector.js.map
